<template>
  <div class="capsule-layer">
    <swiper
      v-if="swiperOptions"
      :ref="refName"
      :options="swiperOptions"
      @mouseenter.native="toggleHover(true)"
      @mouseleave.native="toggleHover(false)"
      @slideChange="onSlideChange"
    >
      <swiper-slide
        v-for="(product, index) in layer.products"
        :key="product.id"
        :data-product-id="product.id"
        :data-layer-id="layer.id"
        :data-filename="product.featured_image"
        :data-product-index="index"
      >
        <div class="boxy">
          <b-img
            :src="imageUrl(product.featured_image)"
            class="img-fluid w-100 d-block"
          />
          <div class="brand">
            <span class="d-inline-block text-block"></span>
          </div>
          <div class="price">
            <span class="d-inline-block text-block"></span>
          </div>
        </div>
      </swiper-slide>
      <div class="swiper-pagination" slot="pagination"></div>
      <div
        class="swiper-button-prev"
        slot="button-prev"
        v-bind:class="{ 'swiper-button-hidden': !hovering }"
      ></div>
      <div
        class="swiper-button-next"
        slot="button-next"
        v-bind:class="{ 'swiper-button-hidden': !hovering }"
      ></div>
    </swiper>
  </div>
</template>

<script>
import { bus } from "@/main";

export default {
  props: {
    layer: {
      type: Object,
      required: true
    }
  },

  data() {
    return {
      hovering: false,
      selectedProductId: null,
      refName: `landingSwiper-${this.layer.id}`,
      swiperOptions: null
    };
  },

  mounted() {
    if (this.layer) {
      this.swiperOptions = {
        initialSlide: 0,
        slidesPerView: 1,
        centeredSlides: true,
        loop: true,
        grabCursor: true,
        speed: 450,
        pagination: {
          el: ".swiper-pagination",
          dynamicBullets: false,
          clickable: true
        },
        navigation: {
          hiddenClass: "swiper-button-hidden",
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        }
      };
    }

    bus.$on("clickingStitchedOutfit", outfit => {
      const obj = this.$lodash.find(outfit, ["layerId", this.layer.id]);

      if (this.swiper && obj) {
        const index = this.$lodash.findIndex(this.layer.products, [
          "id",
          obj.productId
        ]);

        this.swiper.slideTo(index + 1);
      }
    });
  },

  computed: {
    swiper() {
      return this.$refs[this.refName].$swiper;
    }
  },

  methods: {
    onSlideChange() {
      bus.$emit("slidingCarousel");
    },

    toggleHover(value) {
      this.hovering = value;
    },

    imageUrl(filename) {
      return require(`@/assets/img/anatomy/${filename}.png`);
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@/styles/_colour-palette.scss";
@import "~@/styles/_breakpoints.scss";

.capsule-layer {
  cursor: pointer;
  border-top: 1px solid #ffffff;
  border-radius: 0.3em !important;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);

  &:hover {
    border-top: 1px solid #f2f2f2;
    box-shadow: 0px 5px 5px 0px rgba(169, 169, 169, 1);
  }
}

.swiper-button-prev,
.swiper-button-next {
  background-color: $primary-blue;
  opacity: 0.6;

  &:hover {
    opacity: 1;
  }

  &::after {
    font-size: 22px;
    color: #ffffff;
  }
}

.swiper-button-prev {
  margin-left: -10px;
}

.swiper-button-next {
  margin-right: -10px;
}

.swiper-pagination /deep/ {
  .swiper-pagination-bullet {
    margin: -8px 4px !important;
    width: 5px;
    height: 5px;
  }
  .swiper-pagination-bullet-active {
    background-color: #a7a7a7 !important;
  }
}

.boxy {
  width: 100%;
  height: auto;
  margin-bottom: 23px;

  img {
    padding: 5px;
    padding-bottom: 0;

    @include for-tablet-portait-only {
      max-height: 111px;
      padding: 10px;
      padding-bottom: 0;
    }

    @include for-tablet-portrait-up {
      max-height: 122px;
      padding: 10px;
      padding-bottom: 0;
    }

    @include for-tablet-landscape-up {
      max-height: 157px;
      padding: 15px;
      padding-bottom: 0;
    }
    @include for-desktop-up {
      max-height: 194px;
      padding: 15px;
      padding-bottom: 0;
    }
  }
}

.swiper-container {
  background-color: #fff;
  border-top: 1px solid #ffffff;
  text-align: center;

  &:hover {
    border-top: 1px solid #f2f2f2;
    box-shadow: 0px 5px 5px 0px rgba(169, 169, 169, 1);
  }
}

.swiper-button-hidden {
  display: none;
}

.swiper {
  height: auto;

  .swiper-slide {
    line-height: 300px;

    &:nth-child(2n) {
      line-height: 200px;
    }
  }
}
// ----------------------

.brand {
  line-height: 1;

  .text-block {
    margin-top: 10px;
    background-color: #e1e1e1;
    width: 75%;
    height: 10px;
  }
}

.price {
  line-height: 0.8;

  .text-block {
    background-color: #ccc;
    width: 55%;
    height: 8px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/landing/capsuleAnatomy/CapsuleLayer.vue